import * as React from "react";
import "./profileTop.css";
import "../../style/App.css";
import Avatar from "./avatar";
import UserInfo from "./userInfo";
import UserBar from "./userBar";
import BackgroundImage1x from "../../icons/webapp_background_stage/webapp_background_stage.png";
import BackgroundImage2x from "../../icons/webapp_background_stage/webapp_background_stage@2x.png";
import BackgroundImage3x from "../../icons/webapp_background_stage/webapp_background_stage@3x.png";
import LoadingBack1x from "../../icons/loading_Indicator/loading_indicator_bg.png";
import LoadingBack2x from "../../icons/loading_Indicator/loading_indicator_bg@2x.png";
import LoadingBack3x from "../../icons/loading_Indicator/loading_indicator_bg@3x.png";
import LoadingLogo1x from "../../icons/loading_Indicator/loading_indicator_logo.png";
import LoadingLogo2x from "../../icons/loading_Indicator/loading_indicator_logo@2x.png";
import LoadingLogo3x from "../../icons/loading_Indicator/loading_indicator_logo@3x.png";
import { ClipLoader } from "react-spinners";
import translate from "../../translations/i18n";

const ProfileInfo = ({ profile, noProfile }) => {
  if (profile) {
    const username = profile.username;
    const stars_total = profile.stars_total;
    const start_date = profile.start_date;
    const avatar = profile.avatar;
    return (
      <div>
        <div className="profileInfo-Profile">
          <Avatar avatar={avatar} width={160} height={204} />
          <UserInfo
            username={username}
            stars_total={stars_total}
            start_date={start_date}
          />
          {!profile.supporterMode && <UserBar start_date={start_date} />}
          {profile.supporterMode && (
            <div className="TITLE_3 SUPPORTER_TEXT">
              {translate("SUPPORT_APP_WEB_USERINFO")}
            </div>
          )}
          <div className="BACKGROUND_IMAGE">
            <img
              src={BackgroundImage1x}
              srcSet={`${BackgroundImage1x} 1x, ${BackgroundImage2x} 2x, ${BackgroundImage3x} 3x`}
            />
          </div>
        </div>
      </div>
    );
  } else {
    if (noProfile === true) {
      return (
        <div className="NO_PROFILE_CONT">
          <div className="TITLE_2" style={{ textTransform: "uppercase" }}>
            {translate("WEBAPP_INACTIVE_TITLE")}
          </div>
          <div className="REG_TEXT" style={{ paddingTop: 20 }}>
            {translate("WEBAPP_INACTIVE_TEXT")}
          </div>
        </div>
      );
    }
    return (
      <div className="LOADER_CONT">
        <div className="LOADING_ANIMATION_CONT">
          <div className="LOADING_ANIMATION_IMG">
            <img
              src={LoadingLogo1x}
              srcSet={`${LoadingLogo1x} 1x, ${LoadingLogo2x} 2x, ${LoadingLogo3x} 3x`}
            />
          </div>
          <div className="LOADING_ANIMATION_BACK">
            <img
              src={LoadingBack1x}
              srcSet={`${LoadingBack1x} 1x, ${LoadingBack2x} 2x, ${LoadingBack3x} 3x`}
            />
          </div>
        </div>
        <div className="TITLE_3">{translate("LOADING_USER")}</div>
      </div>
    );
  }
};

export default ProfileInfo;



// WEBPACK FOOTER //
// ./src/components/profileTop/profileInfo.tsx